import { takeEvery } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import { isUndefined } from 'underscore';
import { purgeStoredState } from 'redux-persist';
import lockr from 'lockr';
import { browserHistory } from 'react-router';
import localforage from 'localforage';
import alertify from 'alertify.js';

import { fetchApi } from '../utils/api';
import { getProfileRequest } from '../profile/profileActions';
import { registerWebPush } from '../utils/webPushApi';

import {
    deleteTokenSuccess,
    saveTokenSuccess,

    signupSuccess,
    signupFailure,

    signupSchoolSearchSuccess,
    signupSchoolSearchFailure,

    sessionTokenSuccess,
    sessionTokenFailure,

    loginSuccess,
    loginFailure,

    forgetPasswordSuccess,
    forgetPasswordFailure,

    logoutSuccess
} from './authActions';

const {
    AUTH_KEY,
    INTRO_DONE
} = require('../constants').default;

const {
    LOGOUT_REQUEST,
    SIGNUP_REQUEST,
    SIGNUP_SCHOOL_SEARCH_REQUEST,
    SESSION_TOKEN_REQUEST,
    LOGIN_REQUEST,
    FORGET_PASSWORD_REQUEST
} = require('./authActions').constants;

function* deleteSessionToken() {
    lockr.rm(INTRO_DONE);
    lockr.rm(AUTH_KEY);
    yield put(deleteTokenSuccess());
}

function* saveSessionToken(action) {
    lockr.set(AUTH_KEY, action.data.auth_key);
    yield put(saveTokenSuccess());
}

function* logout() {
    yield call(deleteSessionToken);

    // remove state from local storage
    purgeStoredState({ storage: localforage });

    // go to login page
    setTimeout(() => browserHistory.push('/login'), 200);

    yield put(logoutSuccess());
}

function* signup(action) {
    let url = '/auth/sign-up';
    if (action.payload.type === 'parent') {
        url = '/school/sign-up-user';
    } else if (action.payload.type === 'school') {
        url = '/school/sign-up';
    }

    try {
        const response = yield call(fetchApi, {
            method: 'post',
            url,
            body: action.payload.data
        });

        yield call(saveSessionToken, response);
        yield put(signupSuccess(response));

        // navigate to dashboard
        browserHistory.push('/');

        // load user data
        yield put(getProfileRequest());
    } catch (e) {
        alertify.error(e.response ? e.response.data.message : e);
        yield put(signupFailure(e.response ? e.response.data.message : e));
    }
}

function* signupSchoolSearch(action) {
    try {
        const response = yield call(fetchApi, {
            method: 'get',
            url: 'schools',
            params: action.payload
        });

        if (response.data.length === 0) {
            yield put(signupSchoolSearchFailure('Not found'));
            alertify.alert('Invalid invite code');
        } else {
            yield put(signupSchoolSearchSuccess(response));
        }
    } catch (e) {
        alertify.error(e.response ? e.response.data.message : e);
        yield put(signupSchoolSearchFailure(e.response && e.response.data ? e.response.data.message : e));
    }
}

function* checkUserLoggedIn() {
    const response = lockr.get(AUTH_KEY);

    if (!isUndefined(response)) {
        yield put(sessionTokenSuccess(response));

        // load user data
        yield put(getProfileRequest());

        // check web push
        yield call(registerWebPush);
    } else {
        yield put(sessionTokenFailure('token not found'));

        // redirect to login page
        // browserHistory.push('/login');
    }
}

function* login(action) {
    try {
        const response = yield call(fetchApi, {
            method: 'POST',
            url: '/auth/login',
            body: action.payload
        });

        yield call(saveSessionToken, response);
        yield put(loginSuccess(response));

        // navigate to dashboard
        browserHistory.push('/');

        // load user data
        yield put(getProfileRequest());
    } catch (e) {
        alertify.error(e.response ? e.response.data.message : e);
        yield put(loginFailure(e.response ? e.response.data.message : e));
    }
}

function* forgetPassword(action) {
    try {
        const response = yield call(fetchApi, {
            method: 'GET',
            url: '/auth/reset-password',
            params: action.payload
        });

        yield put(forgetPasswordSuccess(response));

        // show alert
        alertify.success('Email has been sent to recover password.');
    } catch (e) {
        alertify.error(e.response ? e.response.data.message : e);
        yield put(forgetPasswordFailure(e.response ? e.response.data.message : e));
    }
}

/**
 * Watch actions
 */
export default function* authSaga() {
    yield* [
        takeEvery(SESSION_TOKEN_REQUEST, checkUserLoggedIn),
        takeEvery(SIGNUP_REQUEST, signup),
        takeEvery(SIGNUP_SCHOOL_SEARCH_REQUEST, signupSchoolSearch),
        takeEvery(LOGIN_REQUEST, login),
        takeEvery(LOGOUT_REQUEST, logout),
        takeEvery(FORGET_PASSWORD_REQUEST, forgetPassword)
    ];
}



/** WEBPACK FOOTER **
 ** ./src/core/auth/authSaga.js
 **/